import { EventEmitter, Component, Renderer2, ViewChild, ViewChildren, ContentChildren, Input, Output, HostListener, NgModule } from '@angular/core';
import { RbacService, StgSecuredObjectDirective } from '@stg-js-ngx-core/oauth';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { HierarchyTreeModule } from '@stg-js-ngx-core/hierarchy-tree';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@stg-js-ngx-core/oauth';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc5 from '@stg-js-ngx-core/hierarchy-tree';

const _c0 = ["toggleButton"];
const _c1 = ["pageHeader"];
function HeaderComponent_img_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 26);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("src", ctx_r2.headerLogo, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeaderComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 27);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.logoText);
} }
function HeaderComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵelementStart(2, "span", 30);
    ɵngcc0.ɵɵelement(3, "i", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_img_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 32);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("src", ctx_r5.profileImageUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeaderComponent_img_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 33);
} }
function HeaderComponent_ng_template_22_Template(rf, ctx) { }
function HeaderComponent_a_23_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const item_r10 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMap(item_r10.iconClass);
} }
function HeaderComponent_a_23_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 40);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r10.subTitle, " ");
} }
function HeaderComponent_a_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 34);
    ɵngcc0.ɵɵelementStart(1, "div", 35);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_a_23_i_2_Template, 1, 2, "i", 36);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 37);
    ɵngcc0.ɵɵelementStart(4, "div", 38);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, HeaderComponent_a_23_div_6_Template, 2, 1, "div", 39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("routerLink", item_r10.page);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r10.iconClass);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r10.title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r10.subTitle);
} }
function HeaderComponent_div_28_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 50);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_div_28_li_10_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r20); const role_r18 = restoredCtx.$implicit; ɵngcc0.ɵɵnextContext(); const _r15 = ɵngcc0.ɵɵreference(4); const ctx_r19 = ɵngcc0.ɵɵnextContext(); ctx_r19.roleChanged(role_r18); return _r15.click(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const role_r18 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(role_r18.role_name);
} }
function HeaderComponent_div_28_app_hierarchy_11_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "app-hierarchy", 51);
    ɵngcc0.ɵɵlistener("nodeSelected", function HeaderComponent_div_28_app_hierarchy_11_Template_app_hierarchy_nodeSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.hierarchySelected($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("showSearch", ctx_r17.enableSearchInTeamSelector)("showSearchButton", ctx_r17.showSearchButtonInTeamSelector)("hierarchyType", ctx_r17.hierarchyType)("liveOnApplication", ctx_r17.liveOnApplication)("selectGlobalSelectedTeamByDefault", true)("syncGlobalTeamSelectionOnClose", true)("selectButton", true);
} }
function HeaderComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵelementStart(2, "div", 41);
    ɵngcc0.ɵɵelementStart(3, "button", 42, 43);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementStart(6, "span", 44);
    ɵngcc0.ɵɵelement(7, "span", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 46);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_div_28_Template_div_click_8_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵelementStart(9, "ul", 47);
    ɵngcc0.ɵɵtemplate(10, HeaderComponent_div_28_li_10_Template, 2, 1, "li", 48);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, HeaderComponent_div_28_app_hierarchy_11_Template, 1, 7, "app-hierarchy", 49);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r9.currentRoleName, " ");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.allRoles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.showTeamSelector);
} }
const _c2 = ["*"];
class HeaderComponent {
    constructor(rbacService, renderer) {
        this.rbacService = rbacService;
        this.renderer = renderer;
        this.enableSearchInTeamSelector = true;
        this.showSearchButtonInTeamSelector = false;
        this.showTeamSelector = false;
        this.teamChanged = new EventEmitter();
        this.selectedRoleName = null;
        this.lastScrollTop = 0;
        this.paddingSetCount = 0;
        this.toggleOptions = {
            target: 'body',
            targetState: 'kt-aside--minimize',
            togglerState: 'kt-aside__brand-aside-toggler--active'
        };
    }
    ngOnInit() {
        document.body.classList.add('kt-header--fixed');
        this.rbacProfile = this.rbacService.rbacProfile;
        this.assignRolesDropdown();
    }
    hierarchySelected(event) {
        this.teamChanged.emit(event);
    }
    onWindowScroll(e) {
        this.adjustHeaderPosition();
    }
    onWindowResize(e) {
        document.getElementById('kt_wrapper').style['padding-top'] = this.pageHeader.nativeElement.offsetHeight + 'px';
    }
    assignRolesDropdown() {
        var _a, _b;
        if (((_b = (_a = this.rbacProfile) === null || _a === void 0 ? void 0 : _a.all_roles) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            this.allRoles = this.rbacProfile.all_roles.sort((a, b) => (a.role_name > b.role_name) ? 1 : ((b.role_name > a.role_name) ? -1 : 0));
            this.currentRoleName = this.rbacProfile.current_role.role_name;
            this.selectedRoleName = this.rbacProfile.current_role.role_name;
        }
    }
    roleChanged(role) {
        this.currentRoleName = role.role_name;
        this.rbacService.switchCurrentRole(role.role_name);
    }
    logOut() {
        this.rbacService.logout();
    }
    adjustHeaderPosition() {
        const pageOffset = window.pageYOffset || document.documentElement.scrollTop;
        if (pageOffset === 0) {
            this.renderer.setStyle(this.pageHeader.nativeElement, 'top', '0');
            this.lastScrollTop = pageOffset;
            return;
        }
        // Make sure they scroll more than delta
        if (Math.abs(this.lastScrollTop - pageOffset) <= 5) {
            return;
        }
        if (pageOffset > this.lastScrollTop && pageOffset > this.pageHeader.nativeElement.offsetHeight) {
            // Scroll Down
            const topValue = '-' + (50 + this.pageHeader.nativeElement.offsetHeight) + 'px';
            this.renderer.setStyle(this.pageHeader.nativeElement, 'top', topValue);
        }
        else {
            // Scroll Up
            if (pageOffset + window.innerHeight < document.documentElement.scrollHeight) {
                this.renderer.setStyle(this.pageHeader.nativeElement, 'top', '0');
            }
        }
        this.lastScrollTop = pageOffset;
    }
    ngAfterViewInit() {
        const header = new KTHeader(this.pageHeader.nativeElement, { classic: { desktop: true, mobile: true } });
        const toggle = new KTToggle(this.toggleButton.nativeElement, this.toggleOptions);
        this.allSecuredObjDirectiveList.toArray().forEach(securedObjectDirective => {
            securedObjectDirective.subscribeToRoleChange();
        });
    }
    ngAfterContentInit() {
        this.allSecuredObjDirectiveListFromTransclusion.toArray().forEach(securedObjectDirective => {
            securedObjectDirective.subscribeToRoleChange();
        });
    }
    ngAfterViewChecked() {
        if (this.paddingSetCount < 20) {
            this.paddingSetCount += 1;
            document.getElementById('kt_wrapper').style['padding-top'] = this.pageHeader.nativeElement.offsetHeight + 'px';
        }
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.RbacService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
HeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["stg-ngx-header"]], contentQueries: function HeaderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, StgSecuredObjectDirective, 4, StgSecuredObjectDirective);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allSecuredObjDirectiveListFromTransclusion = _t);
    } }, viewQuery: function HeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 7);
        ɵngcc0.ɵɵviewQuery(StgSecuredObjectDirective, 5, StgSecuredObjectDirective);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toggleButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pageHeader = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allSecuredObjDirectiveList = _t);
    } }, hostBindings: function HeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function HeaderComponent_scroll_HostBindingHandler($event) { return ctx.onWindowScroll($event); }, false, ɵngcc0.ɵɵresolveWindow)("resize", function HeaderComponent_resize_HostBindingHandler($event) { return ctx.onWindowResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { enableSearchInTeamSelector: "enableSearchInTeamSelector", showSearchButtonInTeamSelector: "showSearchButtonInTeamSelector", showTeamSelector: "showTeamSelector", headerLogo: "headerLogo", logoText: "logoText", profileImageUrl: "profileImageUrl", showQuickPanel: "showQuickPanel", profileMenuItems: "profileMenuItems", hideRoleDropdown: "hideRoleDropdown", hierarchyType: "hierarchyType", liveOnApplication: "liveOnApplication" }, outputs: { teamChanged: "teamChanged" }, ngContentSelectors: _c2, decls: 29, vars: 9, consts: [["id", "kt-header", 1, "kt-header", "kt-grid__item", "kt-header--fixed", "kt-header-mobile", "kt-header-mobile--fixed"], ["pageHeader", ""], ["id", "kt_aside_mobile_toggler", 1, "kt-aside-toggle-button"], ["toggleButton", ""], [1, "fa", "fa-bars", "fa-2x"], [1, "page-logo"], ["routerLink", "/", 1, "page-logo-link"], ["alt", "logo", "class", "header-logo-image", 4, "ngIf"], ["class", "header-logo-text", 4, "ngIf"], [1, "header-nav-bar"], [1, "kt-header__topbar-item"], ["class", "kt-header__topbar-item kt-header__topbar-item--quick-panel", "data-placement", "left", "ngbTooltip", "Quick panel", 4, "ngIf"], ["ngbDropdown", "", "placement", "bottom-right", 1, "kt-header__topbar-item", "kt-header__topbar-item--user"], ["ngbDropdownToggle", "", 1, "kt-header__topbar-wrapper"], [1, "kt-header__topbar-user"], ["alt", "Pic", 4, "ngIf"], ["alt", "", "class", "img-circle", "src", "assets/images/genericAvatar.png", 4, "ngIf"], [1, "username", "username-hide-mobile"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-fit", "dropdown-menu-right", "dropdown-menu-anim"], [1, "kt-notification"], [3, "ngIf"], ["ngbDropdownItem", "", "href", "javascript:;", "class", "kt-notification__item", 3, "routerLink", 4, "ngFor", "ngForOf"], [1, "kt-notification__custom"], [1, "log-out-button", 3, "click"], [1, "fas", "fa-sign-out-alt"], ["class", "kt-header__topbar-item", 4, "ngIf"], ["alt", "logo", 1, "header-logo-image"], [1, "header-logo-text"], ["data-placement", "left", "ngbTooltip", "Quick panel", 1, "kt-header__topbar-item", "kt-header__topbar-item--quick-panel"], [1, "kt-header__topbar-wrapper"], ["id", "kt_quick_panel_toggler_btn", 1, "kt-header__topbar-icon"], [1, "fab", "fa-buffer"], ["alt", "Pic"], ["alt", "", "src", "assets/images/genericAvatar.png", 1, "img-circle"], ["ngbDropdownItem", "", "href", "javascript:;", 1, "kt-notification__item", 3, "routerLink"], [1, "kt-notification__item-icon"], [3, "class", 4, "ngIf"], [1, "kt-notification__item-details"], [1, "kt-notification__item-title", "kt-font-bold"], ["class", "kt-notification__item-time", 4, "ngIf"], [1, "kt-notification__item-time"], [1, "dropdown"], ["type", "button", "id", "teamDropdownMenuButton", "data-bs-toggle", "dropdown", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn", "btn-outline-secondary", "dropdown-toggle", "form-control", "header-dropdown", "role-select-button"], ["roleDropdownButton", ""], [1, "bs-caret"], [1, "caret"], ["aria-labelledby", "teamDropdownMenuButton", "role", "menu", 1, "dropdown-menu", "dropdown-menu-fit", 3, "click"], [1, "role-dropdown-list"], [3, "click", 4, "ngFor", "ngForOf"], ["class", "header-team-select", 3, "showSearch", "showSearchButton", "hierarchyType", "liveOnApplication", "selectGlobalSelectedTeamByDefault", "syncGlobalTeamSelectionOnClose", "selectButton", "nodeSelected", 4, "ngIf"], [3, "click"], [1, "header-team-select", 3, "showSearch", "showSearchButton", "hierarchyType", "liveOnApplication", "selectGlobalSelectedTeamByDefault", "syncGlobalTeamSelectionOnClose", "selectButton", "nodeSelected"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2, 3);
        ɵngcc0.ɵɵelement(4, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "a", 6);
        ɵngcc0.ɵɵtemplate(7, HeaderComponent_img_7_Template, 1, 1, "img", 7);
        ɵngcc0.ɵɵtemplate(8, HeaderComponent_span_8_Template, 2, 1, "span", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 9);
        ɵngcc0.ɵɵelementStart(10, "div", 10);
        ɵngcc0.ɵɵprojection(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, HeaderComponent_div_12_Template, 4, 0, "div", 11);
        ɵngcc0.ɵɵelementStart(13, "div", 12);
        ɵngcc0.ɵɵelementStart(14, "div", 13);
        ɵngcc0.ɵɵelementStart(15, "div", 14);
        ɵngcc0.ɵɵtemplate(16, HeaderComponent_img_16_Template, 1, 1, "img", 15);
        ɵngcc0.ɵɵtemplate(17, HeaderComponent_img_17_Template, 1, 0, "img", 16);
        ɵngcc0.ɵɵelementStart(18, "span", 17);
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 18);
        ɵngcc0.ɵɵelementStart(21, "div", 19);
        ɵngcc0.ɵɵtemplate(22, HeaderComponent_ng_template_22_Template, 0, 0, "ng-template", 20);
        ɵngcc0.ɵɵtemplate(23, HeaderComponent_a_23_Template, 7, 4, "a", 21);
        ɵngcc0.ɵɵelementStart(24, "div", 22);
        ɵngcc0.ɵɵelementStart(25, "a", 23);
        ɵngcc0.ɵɵlistener("click", function HeaderComponent_Template_a_click_25_listener() { return ctx.logOut(); });
        ɵngcc0.ɵɵelement(26, "i", 24);
        ɵngcc0.ɵɵtext(27, "\u00A0\u00A0 Log Out");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(28, HeaderComponent_div_28_Template, 12, 3, "div", 25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerLogo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.logoText && !ctx.headerLogo);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showQuickPanel);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.profileImageUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.profileImageUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.rbacProfile == null ? null : ctx.rbacProfile.first_name);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.profileMenuItems && ctx.profileMenuItems.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.profileMenuItems);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.allRoles && ctx.allRoles.length > 0 && !ctx.hideRoleDropdown);
    } }, directives: [ɵngcc2.RouterLinkWithHref, ɵngcc3.NgIf, ɵngcc4.NgbDropdown, ɵngcc4.NgbDropdownToggle, ɵngcc4.NgbDropdownMenu, ɵngcc3.NgForOf, ɵngcc4.NgbDropdownItem, ɵngcc5.HierarchyTreeComponent], styles: [".kt-header[_ngcontent-%COMP%]{position:fixed!important;top:0;box-shadow:0 1px 6px #32323233!important;transition:all .5s ease;z-index:999}.kt-header-mobile[_ngcontent-%COMP%]{background-color:#fff}.page-logo[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;padding-left:15px}.kt-notification[_ngcontent-%COMP%]   .kt-notification__item[_ngcontent-%COMP%]{border-bottom:1px solid #dcdcdc}.kt-notification[_ngcontent-%COMP%]   .kt-notification__item[_ngcontent-%COMP%]   .kt-notification__item-details[_ngcontent-%COMP%]{white-space:normal}.kt-notification[_ngcontent-%COMP%]   .kt-notification__item[_ngcontent-%COMP%]   .kt-notification__item-icon[_ngcontent-%COMP%]{justify-content:center;flex-direction:row}.kt-notification[_ngcontent-%COMP%]   .kt-notification__item[_ngcontent-%COMP%]:after{display:none!important}.username-hide-mobile[_ngcontent-%COMP%]{margin-left:8px}@media (max-width: 1024px){.kt-header-mobile[_ngcontent-%COMP%]{height:auto!important;flex-wrap:wrap;width:100%}.header-nav-bar[_ngcontent-%COMP%]{flex-wrap:wrap}}@media (max-width: 768px){.username-hide-mobile[_ngcontent-%COMP%]{display:none;margin-left:0}.kt-header__topbar-item[_ngcontent-%COMP%]{margin-right:0!important;padding-top:5px;padding-bottom:5px}}@media (min-width: 1025px){.kt-header-mobile[_ngcontent-%COMP%]{display:flex}.kt-aside-toggle-button[_ngcontent-%COMP%]{display:none!important}.page-logo[_ngcontent-%COMP%]{margin-left:10px}}.kt-header[_ngcontent-%COMP%]{box-shadow:0 1px 10px #32323233}.header-logo-image[_ngcontent-%COMP%]{max-height:50px}.kt-aside-toggle-button[_ngcontent-%COMP%]{display:inline-block;padding:0;border:0;background:none;outline:none!important;box-shadow:none}.img-circle[_ngcontent-%COMP%]{border-radius:50%}.kt-notification[_ngcontent-%COMP%]   .kt-notification__custom[_ngcontent-%COMP%]{justify-content:center!important;border-top:1px solid #e3e3e3;padding:10px 1.2rem}.kt-notification[_ngcontent-%COMP%]   .kt-notification__custom[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none}.header-nav-bar[_ngcontent-%COMP%]{display:flex;flex-direction:row;margin-left:auto}.kt-header__topbar-item[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;margin-right:10px;margin-left:10px}.kt-header__topbar-item[_ngcontent-%COMP%]   .kt-header__topbar-wrapper[_ngcontent-%COMP%]{cursor:pointer;display:flex;flex-wrap:wrap}.kt-header__topbar-item[_ngcontent-%COMP%]   .kt-header__topbar-wrapper[_ngcontent-%COMP%]   .nav-link.dropdown-toggle[_ngcontent-%COMP%]:after, .kt-header__topbar-item[_ngcontent-%COMP%]   .kt-header__topbar-wrapper[_ngcontent-%COMP%]   .btn.dropdown-toggle[_ngcontent-%COMP%]:after{display:none!important}.header-dropdown[_ngcontent-%COMP%]{width:auto}.header-dropdown[_ngcontent-%COMP%]:focus{border-color:#e2e5ec}.role-dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{left:auto!important;right:0!important}.log-out-button[_ngcontent-%COMP%]{text-decoration:none;cursor:pointer}.header-team-select[_ngcontent-%COMP%]{max-width:250px;margin-left:10px}.header-logo-text[_ngcontent-%COMP%]{font-size:26px;color:#7ac142}.page-logo-link[_ngcontent-%COMP%]{text-decoration:none}.role-select-button[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;display:block;text-overflow:ellipsis;padding-right:25px;text-align:left}.role-dropdown-list[_ngcontent-%COMP%]{list-style-type:none;padding:10px;margin-bottom:0}.role-dropdown-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding-top:2px;padding-bottom:2px;text-align:center;font-size:14px}.role-dropdown-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background-color:#edf9ff}  .kt-header .hierarchy-selection-dropdown{min-width:380px!important}"] });
HeaderComponent.ctorParameters = () => [
    { type: RbacService },
    { type: Renderer2 }
];
HeaderComponent.propDecorators = {
    toggleButton: [{ type: ViewChild, args: ['toggleButton', { static: true },] }],
    pageHeader: [{ type: ViewChild, args: ['pageHeader', { static: true },] }],
    allSecuredObjDirectiveList: [{ type: ViewChildren, args: [StgSecuredObjectDirective, {
                    read: StgSecuredObjectDirective
                },] }],
    allSecuredObjDirectiveListFromTransclusion: [{ type: ContentChildren, args: [StgSecuredObjectDirective, {
                    read: StgSecuredObjectDirective
                },] }],
    headerLogo: [{ type: Input }],
    logoText: [{ type: Input }],
    profileImageUrl: [{ type: Input }],
    showQuickPanel: [{ type: Input }],
    profileMenuItems: [{ type: Input }],
    hideRoleDropdown: [{ type: Input }],
    hierarchyType: [{ type: Input }],
    liveOnApplication: [{ type: Input }],
    enableSearchInTeamSelector: [{ type: Input }],
    showSearchButtonInTeamSelector: [{ type: Input }],
    showTeamSelector: [{ type: Input }],
    teamChanged: [{ type: Output }],
    onWindowScroll: [{ type: HostListener, args: ['window:scroll', ['$event'],] }],
    onWindowResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'stg-ngx-header',
                template: "<div class=\"kt-header kt-grid__item kt-header--fixed kt-header-mobile kt-header-mobile--fixed\" #pageHeader id=\"kt-header\">\r\n\r\n  <button class=\"kt-aside-toggle-button\" id=\"kt_aside_mobile_toggler\" #toggleButton>\r\n    <i class=\"fa fa-bars fa-2x\"></i>\r\n  </button>\r\n\r\n  <div class=\"page-logo\">\r\n    <a routerLink=\"/\" class=\"page-logo-link\">\r\n      <img alt=\"logo\" [attr.src]=\"headerLogo\" class=\"header-logo-image\" *ngIf=\"headerLogo\"/>\r\n      <span class=\"header-logo-text\" *ngIf=\"logoText && !headerLogo\">{{ logoText }}</span>\r\n    </a>\r\n  </div>\r\n\r\n  <div class=\"header-nav-bar\">\r\n\r\n    <div class=\"kt-header__topbar-item\">\r\n      <ng-content></ng-content>\r\n    </div>\r\n\r\n    <div class=\"kt-header__topbar-item kt-header__topbar-item--quick-panel\" data-placement=\"left\" ngbTooltip=\"Quick panel\" *ngIf=\"showQuickPanel\">\r\n      <div class=\"kt-header__topbar-wrapper\">\r\n        <span class=\"kt-header__topbar-icon\" id=\"kt_quick_panel_toggler_btn\">\r\n          <i class=\"fab fa-buffer\"></i>\r\n        </span>\r\n      </div>\r\n    </div>\r\n\r\n    <div ngbDropdown placement=\"bottom-right\" class=\"kt-header__topbar-item kt-header__topbar-item--user\">\r\n      <div ngbDropdownToggle class=\"kt-header__topbar-wrapper\">\r\n        <div class=\"kt-header__topbar-user\">\r\n          <img *ngIf=\"profileImageUrl\" alt=\"Pic\" [attr.src]=\"profileImageUrl\">\r\n          <img *ngIf=\"!profileImageUrl\" alt=\"\" class=\"img-circle\" src=\"assets/images/genericAvatar.png\">\r\n          <span class=\"username username-hide-mobile\">{{rbacProfile?.first_name}}</span>\r\n        </div>\r\n      </div>\r\n      <div ngbDropdownMenu class=\"dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim\">\r\n        <!--begin: Navigation -->\r\n        <div class=\"kt-notification\">\r\n          <ng-template [ngIf]=\"profileMenuItems && profileMenuItems.length > 0\"></ng-template>\r\n          <a ngbDropdownItem [routerLink]=\"item.page\" href=\"javascript:;\" class=\"kt-notification__item\" *ngFor=\"let item of profileMenuItems\">\r\n            <div class=\"kt-notification__item-icon\">\r\n              <i [class]=\"item.iconClass\" *ngIf=\"item.iconClass\"></i>\r\n            </div>\r\n            <div class=\"kt-notification__item-details\">\r\n              <div class=\"kt-notification__item-title kt-font-bold\">\r\n                {{item.title}}\r\n              </div>\r\n              <div class=\"kt-notification__item-time\" *ngIf=\"item.subTitle\">\r\n                {{item.subTitle}}\r\n              </div>\r\n            </div>\r\n          </a>\r\n          <div class=\"kt-notification__custom\">\r\n            <a (click)=\"logOut()\" class=\"log-out-button\"><i class=\"fas fa-sign-out-alt\"></i>&nbsp;&nbsp; Log Out</a>\r\n          </div>\r\n        </div>\r\n        <!--end: Navigation -->\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"kt-header__topbar-item\" *ngIf=\"(allRoles && allRoles.length > 0) && (!hideRoleDropdown)\">\r\n      <div class=\"kt-header__topbar-wrapper\">\r\n        <div class=\"dropdown\">\r\n          <button class=\"btn btn-outline-secondary dropdown-toggle form-control header-dropdown role-select-button\"\r\n                  type=\"button\" id=\"teamDropdownMenuButton\" data-bs-toggle=\"dropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" #roleDropdownButton>\r\n            {{currentRoleName}}\r\n            <span class=\"bs-caret\"><span class=\"caret\"></span></span>\r\n          </button>\r\n\r\n          <div class=\"dropdown-menu dropdown-menu-fit\" aria-labelledby=\"teamDropdownMenuButton\" role=\"menu\" (click)=\"$event.stopPropagation()\">\r\n            <ul class=\"role-dropdown-list\">\r\n              <li *ngFor=\"let role of allRoles\" (click)=\"roleChanged(role); roleDropdownButton.click();\">{{role.role_name}}</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n\r\n        <app-hierarchy\r\n          class=\"header-team-select\"\r\n          (nodeSelected)=\"hierarchySelected($event)\"\r\n          [showSearch]=\"enableSearchInTeamSelector\"\r\n          [showSearchButton]=\"showSearchButtonInTeamSelector\"\r\n          [hierarchyType]=\"hierarchyType\"\r\n          [liveOnApplication]=\"liveOnApplication\"\r\n          [selectGlobalSelectedTeamByDefault]=\"true\"\r\n          [syncGlobalTeamSelectionOnClose]=\"true\"\r\n          [selectButton]=\"true\"\r\n          *ngIf=\"showTeamSelector\">\r\n        </app-hierarchy>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n</div>\r\n",
                styles: [".kt-header{position:fixed!important;top:0;box-shadow:0 1px 6px #32323233!important;transition:all .5s ease;z-index:999}.kt-header-mobile{background-color:#fff}.page-logo{display:flex;flex-direction:column;justify-content:center;padding-left:15px}.kt-notification .kt-notification__item{border-bottom:1px solid #dcdcdc}.kt-notification .kt-notification__item .kt-notification__item-details{white-space:normal}.kt-notification .kt-notification__item .kt-notification__item-icon{justify-content:center;flex-direction:row}.kt-notification .kt-notification__item:after{display:none!important}.username-hide-mobile{margin-left:8px}@media (max-width: 1024px){.kt-header-mobile{height:auto!important;flex-wrap:wrap;width:100%}.header-nav-bar{flex-wrap:wrap}}@media (max-width: 768px){.username-hide-mobile{display:none;margin-left:0}.kt-header__topbar-item{margin-right:0!important;padding-top:5px;padding-bottom:5px}}@media (min-width: 1025px){.kt-header-mobile{display:flex}.kt-aside-toggle-button{display:none!important}.page-logo{margin-left:10px}}.kt-header{box-shadow:0 1px 10px #32323233}.header-logo-image{max-height:50px}.kt-aside-toggle-button{display:inline-block;padding:0;border:0;background:none;outline:none!important;box-shadow:none}.img-circle{border-radius:50%}.kt-notification .kt-notification__custom{justify-content:center!important;border-top:1px solid #e3e3e3;padding:10px 1.2rem}.kt-notification .kt-notification__custom a{text-decoration:none}.header-nav-bar{display:flex;flex-direction:row;margin-left:auto}.kt-header__topbar-item{display:flex;flex-direction:column;justify-content:center;margin-right:10px;margin-left:10px}.kt-header__topbar-item .kt-header__topbar-wrapper{cursor:pointer;display:flex;flex-wrap:wrap}.kt-header__topbar-item .kt-header__topbar-wrapper .nav-link.dropdown-toggle:after,.kt-header__topbar-item .kt-header__topbar-wrapper .btn.dropdown-toggle:after{display:none!important}.header-dropdown{width:auto}.header-dropdown:focus{border-color:#e2e5ec}.role-dropdown .dropdown-menu{left:auto!important;right:0!important}.log-out-button{text-decoration:none;cursor:pointer}.header-team-select{max-width:250px;margin-left:10px}.header-logo-text{font-size:26px;color:#7ac142}.page-logo-link{text-decoration:none}.role-select-button{overflow:hidden;white-space:nowrap;display:block;text-overflow:ellipsis;padding-right:25px;text-align:left}.role-dropdown-list{list-style-type:none;padding:10px;margin-bottom:0}.role-dropdown-list li{padding-top:2px;padding-bottom:2px;text-align:center;font-size:14px}.role-dropdown-list li:hover{background-color:#edf9ff}::ng-deep .kt-header .hierarchy-selection-dropdown{min-width:380px!important}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.RbacService }, { type: ɵngcc0.Renderer2 }]; }, { enableSearchInTeamSelector: [{
            type: Input
        }], showSearchButtonInTeamSelector: [{
            type: Input
        }], showTeamSelector: [{
            type: Input
        }], teamChanged: [{
            type: Output
        }], onWindowScroll: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }], onWindowResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], toggleButton: [{
            type: ViewChild,
            args: ['toggleButton', { static: true }]
        }], pageHeader: [{
            type: ViewChild,
            args: ['pageHeader', { static: true }]
        }], allSecuredObjDirectiveList: [{
            type: ViewChildren,
            args: [StgSecuredObjectDirective, {
                    read: StgSecuredObjectDirective
                }]
        }], allSecuredObjDirectiveListFromTransclusion: [{
            type: ContentChildren,
            args: [StgSecuredObjectDirective, {
                    read: StgSecuredObjectDirective
                }]
        }], headerLogo: [{
            type: Input
        }], logoText: [{
            type: Input
        }], profileImageUrl: [{
            type: Input
        }], showQuickPanel: [{
            type: Input
        }], profileMenuItems: [{
            type: Input
        }], hideRoleDropdown: [{
            type: Input
        }], hierarchyType: [{
            type: Input
        }], liveOnApplication: [{
            type: Input
        }] }); })();

class HeaderModule {
}
HeaderModule.ɵfac = function HeaderModule_Factory(t) { return new (t || HeaderModule)(); };
HeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            NgbDropdownModule,
            RouterModule,
            HierarchyTreeModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [HeaderComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    NgbDropdownModule,
                    RouterModule,
                    HierarchyTreeModule
                ],
                exports: [HeaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeaderModule, { declarations: function () { return [HeaderComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        NgbDropdownModule,
        RouterModule,
        HierarchyTreeModule]; }, exports: function () { return [HeaderComponent]; } }); })();

/*
 * Public API Surface of header
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderComponent, HeaderModule };

